<template>
  <div v-if="source" class="message__video-container">
    <slot />
    <video
      ref="player"
      :src="source"
      controls="controls"
      controlsList="nodownload"
      class="message__video"
      data-testid="video-player"
      @play="onPlay"
    />
  </div>
</template>

<script>
export default {
  props: {
    source: { type: String, default: undefined }
  },
  emits: ['play'],
  methods: {
    onPlay() {
      this.$emit('play')
    },
    pause() {
      this.$refs.player.pause()
    }
  }
}
</script>

<style lang="scss">
.message__video-container {
  position: relative;
  line-height: 0;
  overflow: hidden;
  width: fit-content;
}

.message__video {
  max-height: 50vh;
  max-width: 100%;
  z-index: 1;
  position: relative;
  border-radius: var(--gl-border-radius-md);
}
</style>
